import { createSlice } from '@reduxjs/toolkit';

const appSlice = createSlice({
    name: 'app',
    initialState: {
        teams: [],
        sport: 'nfl',
        filters: [],
        loaders: [],
        gameData: [],
        trendIds: [],
        drawer: null,
        subPage: null,
        editGame: null,
    },
    reducers: {
        setTeams(state, action) {
            state.teams = action.payload;
        },
        setSport(state, action) {
            state.sport = action.payload;
        },
        setFilters(state, action) {
            state.filters = action.payload;
        },
        addLoader(state, action) {
            if (!state.loaders.includes(action.payload)) {
                state.loaders.push(action.payload);
            }
        },
        removeLoader(state, action) {
            state.loaders = state.loaders.filter(l => l !== action.payload);
        },
        setGameData(state, action) {
            state.gameData = action.payload;
        },
        setTrendIds(state, action) {
            state.trendIds = action.payload;
        },
        setDrawer(state, action) {
            state.drawer = action.payload;
        },
        setSubPage(state, action) {
            state.subPage = action.payload;
        },
        setEditGame(state, action) {
            state.editGame = action.payload;
        },
    },
});

export const { setTeams, setSport, setFilters, addLoader, removeLoader, setGameData, setTrendIds, setDrawer, setSubPage, setEditGame } = appSlice.actions;
export default appSlice.reducer;
